export const getAboutNewbuildingLink = (url: string): string => {
  return `${url}#info`;
};
